// src/components/Store/Price.jsx
// Precio estilo marketplace: signo y centavos pequeños arriba, pesos grandes.
import React from 'react';

const SIZES = {
  md: { main: 'text-2xl', small: 'text-xs' },
  lg: { main: 'text-4xl', small: 'text-sm' },
};

const Price = ({ amount, size = 'md', className = '' }) => {
  const [pesos, cents] = Number(amount || 0)
    .toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .split('.');
  const s = SIZES[size] || SIZES.md;
  return (
    <span className={`inline-flex items-start leading-none text-[#3A2A20] ${className}`} aria-label={`$${pesos}.${cents} MXN`}>
      <span className={`${s.small} mt-[0.2em] font-medium`}>$</span>
      <span className={`${s.main} font-semibold tracking-tight`}>{pesos}</span>
      <span className={`${s.small} mt-[0.2em] font-medium`}>{cents}</span>
    </span>
  );
};

export default Price;
